import { Navigate, useOutletContext } from 'react-router-dom'

import { CompetenciesProfileRootPageDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/competencies/lib/ProfileCollectionsBootstrap'
import Competencies from 'modules/competencies/pages/employees/Competencies'
import { RouteContext } from 'modules/profile/pages/RootPage'

const Container = () => {
  const { loading: loadingPolicies, data } = useQuery(CompetenciesProfileRootPageDocument)
  const { navigation } = useNavigation()
  const { competenciesAvailable } = useOutletContext<RouteContext>()

  const canManageCompetencies =
    (!loadingPolicies && data?.competencies._policies.competenciesManage.can) || false

  if (!competenciesAvailable && canManageCompetencies)
    return <Navigate replace to={navigation.appStore.fullPath()} />

  if (!competenciesAvailable) return <NotFound />

  return <Competencies />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
